import ScrollReveal from 'scrollreveal'

function init() {
  const revealContainer = ScrollReveal({});
  revealContainer.reveal('.teaser-content, .swiper-container', {
    distance: '200px',
    duration: 1000,
    delay: 0,
    origin: 'bottom',
    opacity: 0,
    scale: 0.9,
    easing: 'cubic-bezier(0.075, 0.82, 0.165, 1)',
    container: window.document.documentElement,
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.2,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
    rotate: { x: 0, y: 0, z: 0 }
  });
  revealContainer.reveal('.product-section-scale div.column-image, .wrapper-tagged-products div.column-image', {
    distance: '100px',
    duration: 1000,
    delay: 0,
    origin: 'bottom',
    opacity: 0,
    scale: 0.8,
    easing: 'cubic-bezier(0.075, 0.82, 0.165, 1)',
    container: window.document.documentElement,
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.2,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
    rotate: { x: 5, y: 0, z: 0 }
  });
  revealContainer.reveal('.img-section-left', {
    duration: 1000,
    opacity: 0,
    scale: 0.8,
    easing: 'cubic-bezier(0.075, 0.82, 0.165, 1)',
    container: window.document.documentElement,
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.2,
    viewOffset: { top: 0, right: 0, bottom: 300, left: 0 },
    rotate: { x: 0, y: 0, z: 0 },
    origin: 'left',
    distance: '150px',
    delay: 0
  });
  revealContainer.reveal('.img-section-right', {
    duration: 1000,
    opacity: 0,
    scale: 0.8,
    easing: 'cubic-bezier(0.075, 0.82, 0.165, 1)',
    container: window.document.documentElement,
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.2,
    viewOffset: { top: 0, right: 0, bottom: 300, left: 0 },
    rotate: { x: 0, y: 0, z: 0 },
    origin: 'right',
    distance: '150px',
    delay: 0
  });
  revealContainer.reveal('.page-new-alpia .medium-order-1.col-image', {
    distance: '100px',
    duration: 1200,
    delay: 0,
    easing: 'cubic-bezier(0.075, 0.82, 0.165, 1)',
    container: window.document.documentElement,
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.2,
    rotate: { x: 0, y: 0, z: 10 },
    scale: 1,
    origin: 'left',
    opacity: 0,
    viewOffset: { top: 0, right: 0, bottom: 100, left: 0 }
  });
  revealContainer.reveal('.page-new-alpia .medium-order-2.col-image', {
    distance: '100px',
    duration: 1200,
    delay: 0,
    easing: 'cubic-bezier(0.075, 0.82, 0.165, 1)',
    container: window.document.documentElement,
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor: 0.2,
    rotate: { x: 0, y: 0, z: 10 },
    scale: 1,
    origin: 'right',
    opacity: 0,
    viewOffset: { top: 0, right: 0, bottom: 100, left: 0 }
  });
}

export default {
  init
}



// WEBPACK FOOTER //
// ./app/components/effects/scrollReveal.js